export const BACKEND_URL = "global.alto.exoware.xyz";
export const PUBLIC_KEY_HEX = "a5e8eb414379bf165cc6f717719c31cd87e062c4e3bd3647ad320dbb0b063b04f288202d7cfb7bbf6ca7ba053c48d36a16015b2977a031ef8294fd8fd943d213c53177c6521ad9fd3fd24cf362879a827a716bac2ca4b29f3c90a87fc2d543c4";
export const LOCATIONS: [[number, number], string][] = [
    [[37.7749, -122.4194], "San Francisco"],
    [[38.8339, -77.3074], "Ashburn"],
    [[53.3498, -6.2603], "Dublin"],
    [[35.6895, 139.6917], "Tokyo"],
    [[59.3293, 18.0686], "Stockholm"],
    [[19.076, 72.8777], "Mumbai"],
    [[-23.5505, -46.6333], "Sao Paulo"],
    [[50.1109, 8.6821], "Frankfurt"],
    [[37.5665, 126.978], "Seoul"],
    [[-33.8688, 151.2093], "Sydney"],
    [[37.7749, -122.4194], "San Francisco"],
    [[38.8339, -77.3074], "Ashburn"],
    [[53.3498, -6.2603], "Dublin"],
    [[35.6895, 139.6917], "Tokyo"],
    [[59.3293, 18.0686], "Stockholm"],
    [[19.076, 72.8777], "Mumbai"],
    [[-23.5505, -46.6333], "Sao Paulo"],
    [[50.1109, 8.6821], "Frankfurt"],
    [[37.5665, 126.978], "Seoul"],
    [[-33.8688, 151.2093], "Sydney"],
    [[37.7749, -122.4194], "San Francisco"],
    [[38.8339, -77.3074], "Ashburn"],
    [[53.3498, -6.2603], "Dublin"],
    [[35.6895, 139.6917], "Tokyo"],
    [[59.3293, 18.0686], "Stockholm"],
    [[19.076, 72.8777], "Mumbai"],
    [[-23.5505, -46.6333], "Sao Paulo"],
    [[50.1109, 8.6821], "Frankfurt"],
    [[37.5665, 126.978], "Seoul"],
    [[-33.8688, 151.2093], "Sydney"],
    [[37.7749, -122.4194], "San Francisco"],
    [[38.8339, -77.3074], "Ashburn"],
    [[53.3498, -6.2603], "Dublin"],
    [[35.6895, 139.6917], "Tokyo"],
    [[59.3293, 18.0686], "Stockholm"],
    [[19.076, 72.8777], "Mumbai"],
    [[-23.5505, -46.6333], "Sao Paulo"],
    [[50.1109, 8.6821], "Frankfurt"],
    [[37.5665, 126.978], "Seoul"],
    [[-33.8688, 151.2093], "Sydney"],
    [[37.7749, -122.4194], "San Francisco"],
    [[38.8339, -77.3074], "Ashburn"],
    [[53.3498, -6.2603], "Dublin"],
    [[35.6895, 139.6917], "Tokyo"],
    [[59.3293, 18.0686], "Stockholm"],
    [[19.076, 72.8777], "Mumbai"],
    [[-23.5505, -46.6333], "Sao Paulo"],
    [[50.1109, 8.6821], "Frankfurt"],
    [[37.5665, 126.978], "Seoul"],
    [[-33.8688, 151.2093], "Sydney"]
];